/**
 * Transforms a flat object with dot notation keys into a nested object structure.
 *
 * @param {Record<string, any>} flatData - The flat object with keys potentially using dot notation
 *                                        (e.g., {'user.name': 'John', 'user.email': 'john@example.com'})
 * @returns {Record<string, any>} A nested object structure where dot notation is converted to nested objects
 *                               (e.g., {user: {name: 'John', email: 'john@example.com'}})
 *
 * @example
 * // Input
 * const flatData = {
 *   'user.name': 'John',
 *   'user.email': 'john@example.com',
 *   'id': 123
 * };
 *
 * // Output
 * // {
 * //   user: {
 * //     name: 'John',
 * //     email: 'john@example.com'
 * //   },
 * //   id: 123
 * // }
 */

export const transformToNestedStructure = (flatData: Record<string, any>) => {
  const nestedData: Record<string, any> = {};

  Object.keys(flatData).forEach((key) => {
    if (key.includes('.')) {
      const [section, field] = key.split('.');

      if (!nestedData[section]) {
        nestedData[section] = {};
      }

      nestedData[section][field] = flatData[key];
    } else {
      nestedData[key] = flatData[key];
    }
  });

  return nestedData;
};
